import { useEffect, useState } from 'react';
import { identity, ifElse } from 'ramda';
import { withProps } from 'recompose';
import { countDownModeTypes } from './constants';

export const initialTimeTillEnd = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    raw: 0
};

export const checkTimeExpiration = ifElse(
    time => new Date(time) > new Date(),
    identity,
    () => null
);

export const defineCountDownTime = (props) => {
    const { modeType, startTime, endTime } = props;

    switch (modeType) {
        case countDownModeTypes.START:
            return checkTimeExpiration(startTime);
        case countDownModeTypes.END:
            return checkTimeExpiration(endTime);
        case countDownModeTypes.MIXED:
            return checkTimeExpiration(startTime)
                || checkTimeExpiration(endTime);
        default:
            return null;
    }
};

export const getTimeTillEnd = (countDownTime) => {
    const diff = new Date(countDownTime) - new Date();

    if (diff > 0) {
        return {
            days: Math.floor(diff / (1000 * 60 * 60 * 24)),
            hours: Math.floor(diff % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
            minutes: Math.floor(diff % (1000 * 60 * 60) / (1000 * 60)),
            seconds: Math.floor(diff % (1000 * 60) / 1000),
            raw: diff
        };
    }

    return initialTimeTillEnd;
};

export const useTimeTillEnd = (props) => {
    const countDownTime = defineCountDownTime(props);
    const [timeTillEnd, setTimeTillEnd] = useState(getTimeTillEnd(countDownTime));

    useEffect(() => setTimeTillEnd(getTimeTillEnd(countDownTime)), [countDownTime]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setTimeTillEnd(getTimeTillEnd(countDownTime));
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [countDownTime, timeTillEnd]);

    return {
        timeTillEnd,
        countDownTime
    };
};

export default withProps(useTimeTillEnd);
